import { useState } from 'react';
import clsx from 'clsx';


//Date-Picker 
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';
import { DateRangePicker, Calendar } from 'react-date-range';
import { CalendarTypes } from 'shared/shared.models';

//Styles
import './calendar.scss';
// import './datePickerLight.scss';
import Color from 'styles/variables.scss';


export interface DatePickerProps {
    type?: CalendarTypes;
    startDatePlaceholder?: string;
    endDatePlaceholder?: string;
    minDate?: Date;
    maxDate?: Date;
    numberOfMonths?: number;
    showDateDisplay?: boolean;
    startDate?: Date;
    endDate?: Date;
    selectSingleDate?: (date) => void; // Calendar
    selectStartDate?: (date) => void; // Date Range
    selectEndDate?: (date) => void; // Date Range
    onDateSelect?: () => void;
}


const DatePicker = (props: DatePickerProps) => {
    const [state, setState] = useState([
        {
            startDate: props.startDate,
            endDate: props.endDate ? props.endDate : null,
            key: 'selection',
            color:  Color.purpleColor
        }
    ])

    const dateSelect = (item) => {
        setState([item.selection]);
        props.selectStartDate(item.selection.startDate);
        props.selectEndDate(item.selection.endDate);
    }
    

    return (
        <div className={clsx("calendar")}>
            {props.type === CalendarTypes.CalendarRange ?
                <DateRangePicker
                    fixedHeight
                    showDateDisplay={props.showDateDisplay}
                    startDatePlaceholder={props.startDatePlaceholder}
                    endDatePlaceholder={props.endDatePlaceholder}
                    minDate={props.minDate}
                    maxDate={props.maxDate}
                    onChange={item => {
                        dateSelect(item);

                        if (props.onDateSelect) {
                            props.onDateSelect();
                        };
                    }}
                    showMonthAndYearPickers={true}
                    moveRangeOnFirstSelection={false}
                    months={props.numberOfMonths}
                    ranges={state}
                    direction="horizontal"
                /> :
                <Calendar
                    fixedHeight
                    color={Color.purpleColor}
                    shownDate={props.startDate}
                    maxDate={props.maxDate}
                    minDate={props.minDate}
                    onChange={date => {
                        props.selectSingleDate(date);
                    }}
                />
            }
        </div>
    )
}


export default DatePicker;